import { UserCustomFilter } from 'core/utils/types/user-custom-filter.type';

export interface FilterCacheEntry {
    originalFilter: UserCustomFilter<unknown>;
    currentFilter: UserCustomFilter<unknown>;
}

const cache = new Map<string, FilterCacheEntry>();
let lastActiveModule: string | null = null;

export const filterCache = {
    setActiveModule(moduleKey: string) {
        if (lastActiveModule && lastActiveModule !== moduleKey) {
            cache.delete(lastActiveModule);
        }
        lastActiveModule = moduleKey;
    },
    cacheFilter(moduleKey: string, entry: FilterCacheEntry) {
        cache.set(moduleKey, entry);
    },
    getCachedFilter(moduleKey: string): FilterCacheEntry | undefined {
        return cache.get(moduleKey);
    },
    clearModule(moduleKey: string) {
        cache.delete(moduleKey);
    },
};
